import React from "react";
import {AggregationGroupSet} from "../../SearchResult";
import TagFacets from "./TagFacets";
import styles from "./VideoSearchFacets.module.css";
import PresentersFacet from "./PresentersFacet";
import {ActiveFacetSet} from "../../SearchReducer";

interface VideoSearchFacetsProps {
    aggs: AggregationGroupSet;
    activeAggregations: ActiveFacetSet;
}

export default function VideoSearchFacets({activeAggregations, aggs}: VideoSearchFacetsProps) {
    return (
        <div className={styles.facets}>
            <PresentersFacet
                aggs={aggs.presenters}
                activeAggregations={activeAggregations.presenters}
            />

            <TagFacets
                aggs={aggs.tags}
                activeAggregations={activeAggregations.tags}
            />
        </div>
    );
}
